export default "__VITE_ASSET__BAq7S20r__"